import React, { useState } from "react";
import {
  Paper,
  Grid,
  Typography,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
} from "@material-ui/core";

function SelectedCompetitionSummary({
  classes,
  selectedCompetition,
  onChangeCompetition,
}) {
  const [confirmOpen, setConfirmOpen] = useState(false);
  if (
    !selectedCompetition ||
    !selectedCompetition.competitionId ||
    selectedCompetition.competitionId === ""
  ) {
    return null;
  }

  const {
    competitionId,
    competitionName,
    competitionLocation,
    competitionDates,
  } = selectedCompetition;

  const renderField = (label, value) => (
    <>
      <Typography className={classes.headerText}>{label}</Typography>
      <Typography className={classes.headerDataText}>{value || "-"}</Typography>
    </>
  );

  return (
    <Grid item xs={12} style={{ marginTop: 24 }}>
      <Paper elevation={3} square style={{ padding: 16 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3}>
            {renderField("Competition ID", competitionId)}
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            {renderField("Competition Name", competitionName)}
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            {renderField("Competition Location", competitionLocation)}
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            {renderField("Competition Dates", competitionDates)}
          </Grid>
        </Grid>
      </Paper>

      <Grid
        container
        alignItems="flex-end"
        justify="flex-end"
        style={{ paddingTop: 20 }}
      >
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            className={classes.buttonStyleChange}
            onClick={() => setConfirmOpen(true)}
          >
            Change Competition
          </Button>
        </Grid>
      </Grid>
      <Dialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogContent>
          <Typography
            className={classes.headerText}
            style={{
              marginTop: "10px",
            }}
          >
            Changing the competition will clear all information you’ve entered
            so far. Do you want to continue?
          </Typography>
        </DialogContent>
        <DialogActions
          style={{
            margin: "10px",
            gap: "12px",
          }}
        >
          <Button
            color="primary"
            className={classes.competitionButtonStyleSummary}
            variant="contained"
            onClick={() => {
              setConfirmOpen(false);
              onChangeCompetition();
            }}
          >
            Change Competition
          </Button>
          <Button
            color="primary"
            className={classes.competitionButtonStyleContinue}
            variant="contained"
            onClick={() => setConfirmOpen(false)}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
}

export default SelectedCompetitionSummary;
